import {
  Component,
  ContentChild,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { ControlContainer } from '@angular/forms';
import { FormComponent } from '../form.components';
import { MultiSelectSettings } from '../multi-select/multi-select.component';
import { Dropdown } from 'primeng/dropdown';

@Component({
  selector: 'hospitality-bot-select',
  templateUrl: './select.component.html',
  styleUrls: ['../form.component.scss', './select.component.scss'],
})
export class SelectComponent extends FormComponent {
  @ViewChild('dropdown') dropdown!: Dropdown;
  // menuClass = 'cdk-virtual-scroll-viewport';
  menuClass = 'p-dropdown-items-wrapper';
  searchInputClass = 'p-dropdown-filter';

  optionAlignment: 'vertical' | 'horizontal' = 'vertical';
  @Input() isAppendToBody: boolean = false;
  @Input() isGroupOptions: boolean = false; // To group options
  @Input() panelStyleClass = '';
  @Output() itemSelection: EventEmitter<any> = new EventEmitter<any>();

  // Templates
  @ContentChild('optionTemplate', { static: false })
  optionTemplate!: TemplateRef<any>;
  @ContentChild('selectedItemTemplate', { static: false })
  selectedItemTemplate!: TemplateRef<any>;
  @ContentChild('groupTemplate', { static: false })
  groupTemplate!: TemplateRef<any>;

  constructor(public controlContainer: ControlContainer) {
    super(controlContainer);
  }

  /**
   * @Input to change default date setting
   */
  @Input() set settings(value: MultiSelectSettings) {
    Object.entries(value)?.forEach(([key, value]) => {
      this[key] = value;
    });
  }

  handleItemChange(event: any): void {
    this.itemSelection.emit(event);
  }

  getTooltipText(option: any): string {
    if (!option) return '';
    const label = option.label || '';
    const extras = option.extras || '';
    return extras ? `${label} ${extras}` : label;
  }

  get selectDropDownClass() {
    return {
      ...this.inputNgClasses,
      'input-margin-top': this.floatInsideLabel,
      select__horizontal:
        this.optionAlignment === 'horizontal' && this.menuOptions?.length,
    };
  }

  get dropdownOption() {
    return this.menuOptions?.length
      ? this.menuOptions
      : [
          {
            label: 'No record found',
            value: 'No record found not to be selected',
            disabled: true,
          },
        ];
  }
}
